import React from 'react';
import * as PropTypes from 'prop-types';
import {
    Descriptions, Skeleton,
} from 'antd';
import './Panels.css';


// See https://ant.design/components/descriptions for more info, 
// This is a basic attempt to give us some default responsive design and styling
// Feel free to update if you can impre the responsive design
// You can use item.value instead of item.children to support basic text fields of varying sizes
// Use item.children if you need more complex behavior than just displaying a value (see ContactDetails.jsx for example of both methods)
const FieldSet = ({ title, items, className, loading, size, layout }) => {

    var keyIndex = 0;
    const displayReadyItems = items.map(item => {
        return {
            ...item,
            children: item.children || item.value,
            key: item.key || keyIndex++,
            span: item.span || (item.value && item.value.length > 25 ? (item.value.length > 50 ? 3 : 2) : 1)
        };
    });

    return (
        <Skeleton active loading={loading}>
            <Descriptions title={title} className={'dp-fieldset ' + className } column={1} layout={layout} size={size} items={displayReadyItems} />
        </Skeleton>
    );

}

// Validate the prop type parameters.
FieldSet.propTypes = {
  title: PropTypes.string, 
  className: PropTypes.string, 
  // columns: PropTypes.oneOf([PropTypes.object, PropTypes.number]),
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  size: PropTypes.string,

};

FieldSet.defaultProps = {
    // columns: { xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 4 },
    size: 'small',
    loading: false,
};

export default FieldSet;
